import Vue from 'vue'
import Router from 'vue-router'
import AppWorld from '@/components/World'
import AppHome from '@/components/Home'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', component: AppHome },
    { path: '/:roomId', component: AppWorld }
  ]
})
